// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface CreatePlaidLinkToken {
  userId?: number
  androidPackageName?: string
  redirectUri?: string
  achApplicationId?: number
}

export interface PlaidLinkTokenResponse {
  errorText?: string
  token?: string
}

/**
 * Validate CreatePlaidLinkToken request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateCreatePlaidLinkToken(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateCreatePlaidLinkToken(request: CreatePlaidLinkToken): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (typeof req.androidPackageName === 'string' && req.androidPackageName.length > 64) {
    errors.push({
      field: 'androidPackageName',
      code: 'too_long',
      message: 'androidPackageName must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.redirectUri === 'string' && req.redirectUri.length > 8192) {
    errors.push({
      field: 'redirectUri',
      code: 'too_long',
      message: 'redirectUri must not exceed 8192 characters',
      argument: '8192'
    })
  }

  return errors
}

export const createPlaidLinkToken = postEndpoint<CreatePlaidLinkToken, PlaidLinkTokenResponse>('/achApplication/createPlaidLinkToken')
